export const TEST_ID = 'pipedrive-slot';

export const SLOT_TITLE = 'Pipedrive';

export const MODAL_TITLE = 'Pipedrive';
export const MODAL_SUBTITLE_INITIAL = 'Learn how to find your token ';
export const MODAL_SUBTITLE_FINAL = 'here';
export const API_TOKEN_LINK = 'https://pipedrive.readme.io/docs/how-to-find-the-api-token';

export const API_GET_DATA_URL = '/api/get-pipe-drive-api-token';
export const API_INTEGRATE_URL = '/api/integrate-pipedrive';
export const API_SUCCESS_OP_MESSAGE = 'Api Token Successfully Saved.';
export const API_FAIL_DEFAULT_OP_MESSAGE = 'Unknown Error';
